import { useState } from "react";
import { PassportState, usePassport } from "../api/passport";
import { useAccount } from "wagmi";
import { ReactComponent as GitcoinPassportLogoFull } from "../../assets/passport-logo-full.svg";
import { ReactComponent as GitcoinPassportLogo } from "../../assets/passport-logo.svg";
import { Dropdown as DropdownIcon } from "common/src/icons/Dropdown";
import { roundToPassportURLMap } from "common";
import { PassportShield } from "./PassportShield";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function PassportWidget(_ref) {
  var _round$roundMetadata;
  let {
    round,
    alignment
  } = _ref;
  const {
    address
  } = useAccount();
  const {
    passportState,
    passportScore,
    passportColor,
    donationImpact
  } = usePassport({
    address,
    round
  });
  const [isOpen, setIsOpen] = useState(false);
  const passportURL = roundToPassportURLMap(round);
  function handleClick() {
    if (passportState === PassportState.SCORE_AVAILABLE || passportState === PassportState.INVALID_PASSPORT) {
      setIsOpen(!isOpen);
    }
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: ((_round$roundMetadata = round.roundMetadata) === null || _round$roundMetadata === void 0 || (_round$roundMetadata = _round$roundMetadata.quadraticFundingConfig) === null || _round$roundMetadata === void 0 ? void 0 : _round$roundMetadata.sybilDefense) === "passport-mbds" ? /*#__PURE__*/_jsx("div", {
      title: "This round is protected by a combination of Passport\u2019s model-based detection system and specialized donation verification.",
      children: /*#__PURE__*/_jsx(GitcoinPassportLogo, {
        className: "h-8 w-8"
      })
    }) : /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row gap-2 mt-1 relative cursor-pointer",
      onClick: () => handleClick(),
      children: [/*#__PURE__*/_jsx("div", {
        className: "pt-4",
        children: alignment === "right" ? /*#__PURE__*/_jsx(GitcoinPassportLogoFull, {}) : /*#__PURE__*/_jsx(GitcoinPassportLogo, {})
      }), passportState === PassportState.SCORE_AVAILABLE ? /*#__PURE__*/_jsxs("div", {
        className: "relative hidden md:flex justify-center items-center",
        children: [/*#__PURE__*/_jsx(PassportShield, {
          color: passportColor
        }), /*#__PURE__*/_jsx("p", {
          className: "absolute text-sm font-modern-era-medium",
          style: {
            top: "50%",
            transform: "translateY(-50%)"
          },
          children: passportScore.toFixed(2)
        })]
      }) : /*#__PURE__*/_jsxs("div", {
        className: "relative hidden md:flex justify-center items-center",
        children: [/*#__PURE__*/_jsx(PassportShield, {
          color: "white"
        }), /*#__PURE__*/_jsx("p", {
          className: "absolute text-sm font-modern-era-medium",
          style: {
            top: "50%",
            transform: "translateY(-50%)"
          },
          children: "0.0"
        })]
      }), /*#__PURE__*/_jsx(DropdownIcon, {
        className: "inline mt-6 md:block",
        direction: isOpen ? "up" : "down"
      }), /*#__PURE__*/_jsx("div", {
        className: `backdrop-blur-[2px] cursor-auto absolute mt-1 top-12 ${alignment === "left" ? "left-[60px] md:left-[-20px]" : ""} border-2
           z-20 ml-[-75px] font-modern-era-medium md:right-0
            md:ml-0 md:mr-[-20px] w-96 bg-white md:bg-white/90 py-4 px-6
             rounded-3xl shadow-lg ${isOpen ? "block" : "hidden"}`,
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col gap-4 mt-1",
          children: [/*#__PURE__*/_jsx(GitcoinPassportLogoFull, {}), passportState === PassportState.SCORE_AVAILABLE ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex flex-row gap-2 w-full justify-center",
              children: [/*#__PURE__*/_jsxs("div", {
                className: `${passportColor === "green" ? "bg-green-100" : passportColor === "yellow" ? "bg-yellow-100" : "bg-orange-100"} w-40 p-4 justify-start rounded-2xl`,
                children: [/*#__PURE__*/_jsx("p", {
                  className: "mb-2",
                  children: "Passport Score"
                }), /*#__PURE__*/_jsx("p", {
                  className: "font-modern-era-regular text-xl",
                  children: passportScore.toFixed(2)
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: `${passportColor === "green" ? "bg-green-100" : passportColor === "yellow" ? "bg-yellow-100" : "bg-orange-100"} w-40 p-4 justify-start rounded-2xl`,
                children: [/*#__PURE__*/_jsx("p", {
                  className: "mb-2",
                  children: "Donation Impact"
                }), /*#__PURE__*/_jsxs("p", {
                  className: "font-modern-era-regular text-xl",
                  children: ["+", donationImpact.toFixed(2), "%"]
                })]
              })]
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-left text-xs font-dm-mono",
              children: ["Your donation impact is calculated based on your Passport score.", round.chainId !== 43114 &&
              /*#__PURE__*/
              // Avalanche chain
              _jsx("span", {
                children: "Scores higher than 15 will begin to be eligible for matching, and your donation impact scales as your Passport score increases."
              }), /*#__PURE__*/_jsxs("span", {
                children: [" ", "You can update your score by heading over to Passport.", " "]
              }), round.chainId === 43114 &&
              /*#__PURE__*/
              // Avalanche chain
              _jsxs("span", {
                children: ["To learn more about the Avalanche Custom Scorer, click", " ", /*#__PURE__*/_jsx("a", {
                  href: "https://support.gitcoin.co/gitcoin-knowledge-base/gitcoin-grants-program/supporter-donor-faq/passport-custom-scorer",
                  className: "underline",
                  children: "here"
                }), "."]
              })]
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-center text-lg",
              children: "Passport score not detected."
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-left text-sm",
              children: ["You either do not have a Passport or no stamps added to your Passport yet. Please head over to", " ", /*#__PURE__*/_jsx("a", {
                href: "https://passport.gitcoin.co",
                className: "underline",
                children: "Passport"
              }), " ", "to configure your score."]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/_jsxs("button", {
              className: "flex flex-row gap-2 bg-gray-800 w-1/2 p-2 rounded-xl text-white text-base",
              onClick: () => window.open(passportURL, "_blank"),
              children: [/*#__PURE__*/_jsx(GitcoinPassportLogo, {
                className: "h-6 w-6"
              }), "Open Passport"]
            })
          })]
        })
      })]
    })
  });
}